// LangSelector V1 and V2

/**
 * @description Returns whether the urlLang is a valid locale format
 * @param {String} urlLang - language from URL
 * @returns {Boolean} True if contextUrlPrefix is a valid config combination
 */
export function isValidLocaleFormat(urlLang) {
    return /^[a-zA-Z]{2}(-[a-zA-Z0-9]{2,3})?$/.test(urlLang);
}


/**
 * langSelectorInit
 * @description A simple language selector navigation tool
 */
export const langSelectorInit = () => {

    const langSelector = document.getElementById('language-selector');

    // Bind Select Menu
    if (langSelector) {
        langSelector.addEventListener('change', function () {
            const path = langSelector.value || '';

            if (path) {
                let languagePreferenceMlp = path.split('/')[1];

                if (isValidLocaleFormat(languagePreferenceMlp)) {
                    languagePreferenceMlp = languagePreferenceMlp.toLowerCase();
                } else {
                    languagePreferenceMlp = 'en';
                }

                try {
                    localStorage.setItem('languagePreferenceMlp', languagePreferenceMlp);
                } catch (e) {}
                // Redirect to the lang url page
                window.location.replace(path);
            }
        });
    }

    // Set localStorage to render client side preferred lang for commerce
    const languageAppCodeMeta = document.getElementsByName('languageAppCode')[0];

    if (languageAppCodeMeta) {
        const lang = languageAppCodeMeta.getAttribute('content');

        // Set localStorage for app lang
        try {
            localStorage.setItem('languagePreference', lang);
        } catch (e) {}
    }
};
